import { WhitelabelConfiguration } from 'src/app/whitelabel/models/whitelabel-config';
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: false,
    name: "filterApp"
})
export default class SearchFilterAppPipe implements PipeTransform {
    transform(apps: WhitelabelConfiguration[], searchTerm: string | null): WhitelabelConfiguration[] {
        if (!searchTerm) return apps;

        const terms = searchTerm
            .split(/[\s,;]+/)
            .map(term => term.trim().toLowerCase())
            .filter(term => term.length > 0);

        if (terms.length === 0) return apps;

        const filteredApps = apps.filter(app => {
            const name = app.name.toLowerCase();
            const accountantId = app.accountantId.toLowerCase();
            return terms.some(term => name.includes(term) || accountantId.includes(term));
        });
        return filteredApps
    }
}